/** @module Apparel/ProductSize/MaterialSizesRenderer */
define([
   	"dojo/_base/declare",
	"./ProductSizesRenderer"
], function(declare,ProductSizesRenderer) {

	return declare(ProductSizesRenderer, {
		/**
		 * @override
		 * Disable copying from a material with owned sizes
		 */
		canCopy: function(ctxCopy, h) {
			return ctxCopy.getNode().OwnedProductSizes.length == 0;
		}
	});
});